<template>
  <section>
    <Form :model="query" inline>
      <FormItem>
        <Input clearable v-model="query.name" placeholder="表名称"></Input>
      </FormItem>
      <FormItem>
        <Select style="width: 170px" v-model="query.flag" clearable placeholder="是否同步数据库">
          <Option value="1">已同步</Option>
          <Option value="0">未同步</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button icon="ios-search" shape="circle" @click="querySubmit()">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" icon="md-add" shape="circle" @click="newForm()">新增</Button>
      </FormItem>
      <FormItem>
        <Button type="warning" icon="md-archive" shape="circle" @click="dbExport()">数据库导入</Button>
      </FormItem>
    </Form>
    <Table border :columns="columns" :data="tableData"></Table>
    <div class="page-div">
      <Page :total="dataCount" :page-size="pageSize" :current="page+1" @on-change="handlePageChange" show-total show-elevator/>
    </div>

    <generate-form ref="GenerateForm"></generate-form>
    <export-win ref="ExportWin"></export-win>
  </section>
</template>

<script>
  import Util from '@/libs/util.js';
  import GenerateForm from './components/form/GenerateForm';
  import ExportWin from './components/form/ExportWin';

  export default {
    components: {ExportWin, GenerateForm},
    data () {
      return {
        name: 'FormList',
        query: {
          name: '',
          flag: ''
        },
        dataCount: 0,
        pageSize: 6,
        page: 0,
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: '表名称',
            width: 200,
            key: 'name'
          },
          {
            title: '表单名称',
            width: 250,
            key: 'mark'
          },
          {
            title: '表单类型',
            width: 100,
            key: 'type'
          },
          {
            title: '表单模板',
            width: 150,
            key: 'template'
          },
          {
            title: '同步数据库',
            width: 100,
            key: 'flag'
          },

          {
            title: '操作',
            key: 'id',
            render: (h, params) => {
            let d_flag = params.row.flag;
      if (d_flag === '已同步') {
        return h('div', [
          h('Button', {
            props: {
              type: 'primary',
              size: 'small'
            },
            on: {
              click: () => {
              this.edit(params.row.id);
      }
      }
      }, '编辑'),
        h('Button', {
          props: {
            type: 'error',
            size: 'small'
          },
          style: {
            marginLeft: '5px'
          },
          on: {
            click: () => {
            this.delete(params.row.id);
      }
      }
      }, '删除'),
        h('Button', {
          props: {
            type: 'info',
            size: 'small'
          },
          style: {
            marginLeft: '5px'
          },
          on: {
            click: () => {
            this.generateCode(params.row.id);
      }
      }
      }, '生成代码')

      ]);
      } else {
        return h('div', [
          h('Button', {
            props: {
              type: 'primary',
              size: 'small'
            },
            on: {
              click: () => {
              this.edit(params.row.id);
      }
      }
      }, '编辑'),
        h('Button', {
          props: {
            type: 'error',
            size: 'small'
          },
          style: {
            marginLeft: '5px'
          },
          on: {
            click: () => {
            this.delete(params.row.id);
      }
      }
      }, '删除'),
        h('Button', {
          props: {
            type: 'info',
            size: 'small'
          },
          style: {
            marginLeft: '5px'
          },
          on: {
            click: () => {
            this.generateCode(params.row.id);
      }
      }
      }, '生成代码'),
        h('Button', {
          props: {
            type: 'default',
            size: 'small'
          },
          style: {
            marginLeft: '5px'
          },
          on: {
            click: () => {
            this.syncDb(params.row.id);
      }
      }
      }, '同步数据库')

      ]);
      }

    }
    },
    ],
      tableData: []
    };
    },
    mounted () {
      this.listTable();
    },
    methods: {
      dbExport () {
        this.$refs.ExportWin.modalVisible = true;
      },
      listTable () {
        let This = this;
        const [url, httpConfig] = [
          '/api/formTablesByCriteria',
          {
            params: {
              page: This.page,
              size: This.pageSize,
              'tableName.contains': This.query.name,
              'isDbSynch.equals': This.query.flag,
            }
          }
        ]
        This.$http.get(url, httpConfig).then(function (response) {
          This.tableData = [];
          let data = response.data;
          This.dataCount = data.recordsTotal;
          let list = data.data;
          for (let i = 0; i < list.length; i++) {
            let form = list[i];
            let typeName = '';
            if (form.formType === 0) {
              typeName = '单表';
            }
            if (form.formType === 1) {
              typeName = '主表';
            }
            if (form.formType === 2) {
              typeName = '附表';
            }
            if (form.formType === 3) {
              typeName = '工作流表';
            }
            let map = {
              id: form.id,
              name: form.tableName,
              type: typeName,
              template: form.codeTemplateSuite !== null ? form.codeTemplateSuite.suiteCode + '-' + form.codeTemplateSuite.suiteVersion : '',
              flag: form.isDbSynch === 0 ? '未同步' : '已同步',
              mark: form.tableContent
            };
            This.tableData.push(map);
          }
        })
          .catch(function (error) {
            console.log(error);
          });
      },
      edit (id) {
        this.$router.push({
          name: 'form-edit',
          query: {
            id: id
          }
        });
      },
      delete (id) {
        let This = this;
        this.$Modal.confirm({
          title: '确定删除？',
          content: '提示：该删除不会删除数据库表',
          onOk () {
            This.$http.delete('/api/formTables/' + id).then(response => {
              if (response.status === 200) {
              This.$Notice.success({
                title: '删除成功'
              });
              This.listTable();
            } else {
              This.$Notice.error({
                title: '删除失败'
              });
            }
          });
          }
        });

      },
      generateCode (id) {
        this.$refs.GenerateForm.modalVisible = true;
        this.$refs.GenerateForm.generate.id = id;
      },
      syncDb (id) {
        let This = this;
        This.$http.put('/api/sync/' + id).then(function (response) {

          This.$Notice.success({
            title: '同步成功！'
          });
          This.listTable();

        })
          .catch(function (error) {
            This.$Notice.error({
              title: '同步失败！'
            });
            console.log(error);
          });
      },
      newForm () {
        /*this.$store.commit('setInfo',[ {
            fieldName: '',
            content: '',
            length: '',
            pointLength: '',
            defaultValue: '',
            type: '',
            isNull: false,
            isKey: false,
            orderNum: 1,
            isShow: false,
            isShowList: false,
            fieldLength: 320,
            isQuery: false,
            queryMode: null,
            showType: null
        }])*/
        this.$router.push({
          name: 'form-add',
        });
      },
      querySubmit () {
        this.page = 0;
        this.listTable();
      },
      handlePageChange (current) {
        this.page = current - 1;
        this.listTable();
      }
    }

  };
</script>

<style scoped>
  .page-div {
    display: flex;
    justify-content: flex-end;
    padding-top: 35px;
    padding-right: 50px;
  }
</style>
